import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';

import Heading from '@marvelapp/marvel-ui/heading';
import Select from '@marvelapp/marvel-ui/select';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import devSidebarLinks from 'marketing-website/configs/devSidebarLinks.js';
import generalStyles from './style/general.module.css';

class DevSubNav extends Component {
  onChange = event => {
    this.props.history.push(event.target.value);
  };

  render() {
    const options = [];
    const { hasScrolled, location } = this.props;

    devSidebarLinks.map(item =>
      options.push({ value: item.url, label: item.title })
    );

    const wrapClasses = cx(generalStyles.subnav, {
      [generalStyles.hasNotScrolled]: !hasScrolled,
      [generalStyles.hasScrolled]: hasScrolled,
    });

    return (
      <div className={wrapClasses}>
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={3} columnSpanS={2}>
            <Heading tag="h5" weight="normal" size="s" color="silver">
              Contents
            </Heading>
          </GridItem>
          <GridItem columnSpan={9} columnSpanS={10}>
            <Select
              fullWidth
              onChange={event => this.onChange(event)}
              options={options}
              size="s"
              value={location.pathname}
            />
          </GridItem>
        </Grid>
      </div>
    );
  }
}

export default withRouter(DevSubNav);

DevSubNav.propTypes = {
  hasScrolled: PropTypes.bool,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

DevSubNav.defaultProps = {
  DevSubNav: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/DevSubNav/index.js